import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'

import { NgIf } from '@angular/common'
import { convertCurrency } from '../../utils/utils'

@Component({
  selector: 'table-list-purchase-reservation-tg',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    NgIf,
  ],
  templateUrl: './table-list-purchase-reservation-tg.component.html',
  styleUrl: './table-list-purchase-reservation-tg.component.scss',
})
export class TableListPurchaseReservationTgComponent
  implements OnInit, OnChanges
{
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Output() viewItem = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  formatCurrency(value: any): string {
    return value != null ? `R$ ${convertCurrency(value)}` : '-'
  }
}
